const WorkInProgressBadge = () => {
    return (
        <div className="flag badge badge-warning gap-2 font-bold">
            🚧 Work in Progress
        </div>
    )
}

export default WorkInProgressBadge